import { NAME } from './configs.constant';

export const selectState = (state) => state[NAME];
